// extracted by mini-css-extract-plugin
export default {"infoNote":"InfoNote_infoNote__6g1Oz"};